module.exports = __webpack_public_path__ + "img/cg_logo_dark.a49100cb.svg";